module.exports = __webpack_public_path__ + "img/thegammacollection.90ef11d8.png";